// extracted by mini-css-extract-plugin
export var actions = "_2g-0";
export var actionsContainer = "_2g-7";
export var border = "_2g-1";
export var childFullHeight = "_2g-f";
export var collapse = "_2g-2";
export var content = "_2g-a";
export var contentChild = "_2g-e";
export var fullscreen = "_2g-c";
export var hasLeftRadius = "_2g-k";
export var headerContainer = "_2g-3";
export var headerRow = "_2g-5";
export var hidePadding = "_2g-b";
export var navCollapsedGap = "_2g-l";
export var noScrollX = "_2g-m";
export var noScrollY = "_2g-n";
export var noTopPadding = "_2g-i";
export var optOutTopPadding = "_2g-d";
export var pageMain = "_2g-j";
export var pageOuter = "_2g-g";
export var pagePadding = "_2g-8";
export var pageScroll = "_2g-9";
export var profile = "_2g-o";
export var profileContainer = "_2g-p";
export var profileImage = "_2g-q";
export var profileMain = "_2g-r";
export var profileSubtitle = "_2g-t";
export var profileTitle = "_2g-s";
export var showLeftPadding = "_2g-h";
export var tabsPortalSlot = "_2g-6";
export var tabsWrapper = "_2g-4";
export var title = "_2g-u";